// extracted by mini-css-extract-plugin
module.exports = {"fullHeaderFont":"400 13px \"GalanoGrotesque-SemiBold\",serif","tertiaryFont":"\"CoreSansA65Bold\""};